module.exports = __webpack_public_path__ + "img/9-10.354470d6.png";